import React from 'react'

import { useSelectedSigEvent } from '../hooks'

import SigEventsList from './SigEventsList'
import SigEventsDetailsPanel from './SigEventsDetailsPanel'

const SigEventsPanel = () => {
  const current = useSelectedSigEvent()

  if (current) return <SigEventsDetailsPanel />
  return <SigEventsList />
}
export default SigEventsPanel
